import { render, staticRenderFns } from "./MdHistoricalAppointment.vue?vue&type=template&id=46e59caa&"
import script from "./MdHistoricalAppointment.vue?vue&type=script&lang=js&"
export * from "./MdHistoricalAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports